import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=330d89f3&scoped=true"
import script from "./documentation.vue?vue&type=script&lang=js"
export * from "./documentation.vue?vue&type=script&lang=js"
import style0 from "./documentation.vue?vue&type=style&index=0&id=330d89f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d89f3",
  null
  
)

export default component.exports